import React, { Component } from 'react'

import { DatePicker } from '../../utilites'

class ModalRegistryContent extends Component {

  render(props) {
    return (
      <div>
        <fieldset>
          <div className="d-flex align-baseline flex-space-between">
            <p className="m-r-spacer"><big>Предыдущий №70 от 09.12.2020, Воробьёва Наталья</big></p>
            <span className="label">МН16</span>
          </div>
        </fieldset>
        <fieldset>
          <div className="form-element">
            <label className="form-element-label" htmlFor="#">Подразделение</label>
            <div className="form-element-data">
              <select className="input">
                <option>Выберите…</option>
              </select>
            </div>
          </div>
          <div className="form-element">
            <label className="form-element-label" htmlFor="">Номер документа</label>
            <div className="form-element-data">
              <input className="input" type="text" name="" id="" />
            </div>
          </div>
          <div className="form-element">
            <label className="form-element-label" htmlFor="#">Дата</label>
            <div className="form-element-data date">
              <DatePicker />
            </div>
          </div>
        </fieldset>
      </div>
    )
  }
}

export default ModalRegistryContent
